<!--
  - Copyright (c) 2025. Haodong JU
  -->

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import userMembership, { editUserPoint } from '@/model/dataLayer/api/MembershipSystem/UserMembership'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import GlobalConfig from '@/model/global/GlobalSettings'
import { showSuccessMessage } from '@/model/utils/utils'
import Asset, { distributeAssetToUser } from '@/model/dataLayer/api/MembershipSystem/Asset'
import { VSelect } from 'vuetify/lib/components'
import UserDetailsDialog from './UserDetailsDialog/index.vue'

export default {
  name: 'UserList',
  components: {
    UserDetailsDialog,
    BaseForm,
    IkDataTable
  },
  data () {
    return {
      assetList: [],
      giveAssetDialog: false,
      formLoading: false,
      sendPointDialog: false,
      userDetailsDialog: false,
      editObject: null,
      selectedUserId: null,
      model: userMembership
    }
  },
  async mounted () {
    await this.reload()
  },
  computed: {
    pointSchemas () {
      return [
        {
          key: 'points',
          name: 'points',
          hint: '若是减少积分需要添加-符号' + `(原积分为:${this.editObject?.currentPoints ?? 0})`
        },
        {
          key: 'description',
          name: 'description',
          required: false,
          default: '',
          componentProps: {
            rules: []
          }
        }
      ]
    },
    giftSchemas () {
      return [
        {
          key: 'assetId',
          name: 'assetId',
          component: VSelect,
          componentProps: {
            items: this.assetList.map(it => {
              it.text = it.name
              it.value = it.id
              return it
            })
          }
        },
        {
          key: 'note',
          name: 'note',
          required: false,
          default: '',
          componentProps: {
            rules: []
          }
        }
      ]
    }
  },
  methods: {
    async saveAssetGive (info) {
      this.formLoading = true
      await distributeAssetToUser(info.assetId, { userId: this.editObject?.userId, note: info.note })
      showSuccessMessage('成功！')
      await this.$refs.table.reload()
      this.formLoading = false
      this.giveAssetDialog = false
    },
    giveAsset (item) {
      this.editObject = item
      this.giveAssetDialog = true
    },
    async savePointEdit (info) {
      this.formLoading = true
      info.userId = this.editObject?.userId
      info.blId = GlobalConfig.blId
      await editUserPoint(info)
      showSuccessMessage('成功！')
      await this.$refs.table.reload()
      this.formLoading = false
      this.sendPointDialog = false
    },
    editPoint (item) {
      this.editObject = item
      this.sendPointDialog = true
    },
    async reload () {
      this.assetList = await Asset.getList(true)
    },
    showUserDetails (item) {
      this.selectedUserId = item.userId
      this.userDetailsDialog = true
    }
  }
}
</script>

<template>
  <v-container>
    <ik-data-table
      ref="table"
      :custom-on-row-click="showUserDetails"
      :item-key="'userId'"
      :model="model"
      :use-add-action="false"
      :use-delete-action="false"
      :use-edit-action="false"
      entity-name="会员管理"
      icon="mdi-cash-usd"
    >
      <template #item.operations="{item}">
        <div class="d-flex">
          <v-tooltip
            bottom
            color="grey lighten-4"
          >
            <template #activator="{on,attrs}">
              <div
                class="d-flex align-center"
                v-bind="attrs"
                v-on="on"
              >
                <v-btn
                  elevation="0"
                  icon
                  small
                  @click.stop="editPoint(item)"
                >
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <div
              class="text-caption text--secondary"
            >
              {{ '修改积分' }}
            </div>
          </v-tooltip>
          <v-tooltip
            bottom
            color="grey lighten-4"
          >
            <template #activator="{on,attrs}">
              <div
                class="d-flex align-center"
                v-bind="attrs"
                v-on="on"
              >
                <v-btn
                  elevation="0"
                  icon
                  small
                  @click.stop="giveAsset(item)"
                >
                  <v-icon>
                    mdi-gift-open-outline
                  </v-icon>
                </v-btn>
              </div>
            </template>
            <div
              class="text-caption text--secondary"
            >
              {{ '赠送资产' }}
            </div>
          </v-tooltip>
        </div>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="sendPointDialog"
      max-width="600px"
    >
      <base-form
        :loading="formLoading"
        :schema="pointSchemas"
        @close="sendPointDialog=false"
        @submit="savePointEdit"
      >
        修改积分
      </base-form>
    </v-dialog>
    <v-dialog
      v-model="giveAssetDialog"
      max-width="600px"
    >
      <base-form
        :loading="formLoading"
        :schema="giftSchemas"
        @close="giveAssetDialog=false"
        @submit="saveAssetGive"
      >
        赠送资产
      </base-form>
    </v-dialog>
    <user-details-dialog
      v-model="userDetailsDialog"
      :user-id="selectedUserId"
    />
  </v-container>
</template>

<style scoped>
</style>
